import { uploadToSignedUrl } from './storageUpload';

const API_URL = process.env.REACT_APP_API_URL || 'https://orders.fletaime.com';

// Short-lived pairing id for the "add photos from phone" QR flow - only
// ever used as a Storage folder name (see server/mobileUploadController.js),
// never as an auth secret, so a random-looking token is enough; anyone who
// guesses it could only see/add photos in that one throwaway session folder.
export function createMobileSessionId() {
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
}

export function getMobileUploadUrl(sessionId) {
  return `${window.location.origin}/mobile-upload/${sessionId}`;
}

// Requests one signed upload URL per filename - mirrors getPhotoUploadTokens
// in storageUpload.js but keyed by a pairing sessionId instead of an orderId.
export async function getMobileSessionTokens(sessionId, fileNames) {
  const response = await fetch(`${API_URL}/api/mobile-session/photo-tokens`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sessionId, fileNames }),
  });
  if (!response.ok) throw new Error(`Gabim gjatë përgatitjes së ngarkimit (${response.status}).`);
  const data = await response.json();
  if (!data.success) throw new Error('Gabim gjatë përgatitjes së ngarkimit.');
  return data.tokens || [];
}

// Uploads one batch of files straight to Storage from the phone page.
export async function uploadFilesForMobileSession(sessionId, files, { onProgress } = {}) {
  const tokens = await getMobileSessionTokens(sessionId, files.map(f => f.name));
  const tokenByFileName = new Map(tokens.map(t => [t.fileName, t]));
  let done = 0;
  const failed = [];

  for (const file of files) {
    const token = tokenByFileName.get(file.name);
    if (token) {
      try {
        await uploadToSignedUrl(token.signedUrl, file);
      } catch (err) {
        console.error(`Mobile session upload failed for ${file.name}:`, err);
        failed.push(file.name);
      }
    } else {
      failed.push(file.name);
    }
    done++;
    if (onProgress) onProgress(done, files.length);
  }
  return { uploaded: files.length - failed.length, failed };
}

// Polled by the desktop pairing modal to pick up whatever the phone has
// uploaded to this session so far.
export async function listMobileSessionPhotos(sessionId) {
  const response = await fetch(`${API_URL}/api/mobile-session/${sessionId}/photos`);
  if (!response.ok) throw new Error(`Gabim gjatë listimit (${response.status}).`);
  const data = await response.json();
  if (!data.success) throw new Error('Gabim gjatë listimit.');
  return data.photos || [];
}

// Best-effort cleanup once the desktop has pulled a photo into its own
// uploadedPhotos - never awaited by callers that don't care about the result.
export async function deleteMobileSessionPhotos(sessionId, paths) {
  if (!paths || paths.length === 0) return;
  try {
    await fetch(`${API_URL}/api/mobile-session/${sessionId}/photos`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ paths }),
    });
  } catch (err) {
    console.warn('Mobile session cleanup failed (non-fatal):', err);
  }
}
